import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const ProjectViewer: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (projectId) {
      // Redirect to inspection page with project ID as query param
      navigate(`/inspection?project=${projectId}`);
    }
  }, [projectId, navigate]);

  return <div style={{ padding: '40px', textAlign: 'center' }}>Loading project...</div>;
};

export default ProjectViewer;
